import './CompletedMovement.scss';
import { useEffect, useState } from 'react';
import Hub from '../../api/controllers/Hub/Hub';
import AssociatedPackageList from '../PendingMovement/subComponents/AssociatedPackageList/AssociatedPackageList';
import Modal from '../../common/Modal/Modal';
import MovementDetails from '../../common/MovementDetails/MovementDetails';
import MovementNotesPhotos from '../../common/MovementNotesPhotos/MovementNotesPhotos';
import PropTypes from 'prop-types';
import Job from '../../api/controllers/Job/Job';
import Packages from '../../api/controllers/Packages/Packages';
import PackageList from '../../common/PackageList/PackageList';
import UnconfirmModal from './subComponents/UnconfirmModal/UnconfirmModal';
import { useLocation, useNavigate } from 'react-router-dom';
import Button from '../../common/Button/Button';
import Error from '../../common/Error/Error';
import GoodsOut from '../../api/controllers/GoodsOut/GoodsOut';

// CompletedMovement screen Component
const CompletedMovement = ({
  getMovement,
  movement,
  setError,
  setLoading,
  category,
  movementType,
}) => {
  const navigate = useNavigate();
  const [bays, setBays] = useState();
  const [racks, setRacks] = useState();
  const [baysAndRacks, setBaysAndRacks] = useState();
  const [modalOpen, setModalOpen] = useState();
  const [job, setJob] = useState();
  const [packages, setPackages] = useState([]);
  const [completedPackages, setCompletedPackages] = useState([]);

  const location = useLocation();

  const hubId = JSON.parse(localStorage.getItem('user')).currentHubId;

  const jobs = movement?.assignments
    ?.map(assignment => assignment.job)
    .filter((x, i, a) => a.indexOf(x) == i);

  const expQuantity = movement?.assignments?.map(a => a?.quantity).reduce((a, b) => a + b, 0);
  const expType = movement?.assignments[0]?.packageType?.shortName
    ? movement?.assignments?.every(
        assignment =>
          assignment?.packageType?.shortName == movement?.assignments[0]?.packageType?.shortName,
      )
      ? movement?.assignments[0]?.packageType?.shortName
      : 'pkg'
    : 'pkg';
  const actPackageArray =
    movementType == 'collections' || movementType == 'imports'
      ? [...packages, ...completedPackages]
      : packages;
  const actQuantityPackages = actPackageArray?.length;
  const actQuantityItems = actPackageArray?.map(pkg => pkg?.quantity).reduce((a, b) => a + b, 0);
  const actType =
    actPackageArray && actPackageArray[0]?.packageType?.shortName
      ? actPackageArray?.every(
          pkg => pkg?.packageType?.shortName == actPackageArray[0]?.packageType?.shortName,
        )
        ? actPackageArray[0]?.packageType?.shortName
        : 'pkg'
      : 'pkg';
  const expWeight = movement?.assignments?.map(a => a?.grossWeightKg).reduce((a, b) => a + b, 0);
  const actWeight = actPackageArray?.map(pkg => pkg?.grossWeightKg).reduce((a, b) => a + b, 0);
  const expVolume = movement?.assignments
    ?.map(a => Number(a?.cubicMetres))
    .reduce((a, b) => a + b, 0)
    .toFixed(2);

  const actVolume = actPackageArray
    ?.map(pkg => Number(pkg?.cubicMetres))
    .reduce((a, b) => a + b, 0)
    .toFixed(2);

  const driverName = movement?.warehouseData?.driverName;
  const driverSignature = movement?.warehouseData?.driverSignature;

  const getModalType = () => {
    switch (modalOpen) {
      case 'unconfirm':
        return (
          <UnconfirmModal
            category={category}
            id={movement.id}
            movementType={movementType}
            setModalOpen={setModalOpen}
            refreshMovement={getMovement}
          />
        );
    }
  };

  const getBays = async () => {
    setLoading(true);
    Hub.show(hubId)
      .then(response => {
        setBaysAndRacks(response.bays);
        setBays(response.bays.filter(bay => bay.bayType != 'racking'));
        const racks = response.bays.filter(bay => bay.bayType == 'racking');
        setRacks(Object.groupBy(racks, rack => rack.bayNumber));
        setLoading(false);
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  const getJob = () => {
    setLoading(true);
    Job.show(movement?.assignments[0]?.job?.id)
      .then(response => {
        setLoading(false);
        setJob(response);
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  const getCompletedPackages = () => {
    setLoading(true);
    const params =
      movementType == 'collections' || movementType == 'imports'
        ? { goodsInType: movement?.modelName, goodsInId: movement?.id, status: 'complete' }
        : { goodsOutType: movement?.modelName, goodsOutId: movement?.id, status: 'complete' };
    Packages.all(params)
      .then(response => {
        setLoading(false);
        setCompletedPackages(response.items);
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  const getIncompletePackages = () => {
    setLoading(true);
    const params =
      movementType == 'collections' || movementType == 'imports'
        ? { goodsInType: movement?.modelName, goodsInId: movement?.id, status: 'in_warehouse' }
        : { goodsOutType: movement?.modelName, goodsOutId: movement?.id };
    Packages.all(params)
      .then(response => {
        setLoading(false);
        setPackages(response.items);
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  const [relatedExports, setRelatedExports] = useState();

  const getRelatedExports = () => {
    setLoading(true);
    const params = { category: 'international', jobId: job?.id };
    GoodsOut.all(params)
      .then(response => {
        setRelatedExports(response.items);
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  useEffect(() => {
    getBays();
    getJob();
  }, [location]);

  useEffect(() => {
    if (job) {
      getCompletedPackages();
      getIncompletePackages();
    }
    if (movementType == 'collections') {
      getRelatedExports();
    }
  }, [job]);

  return (
    <div data-testid="completed_container">
      {relatedExports?.map(relatedExport => {
        if (relatedExport.expectedBayId) {
          return (
            <Error
              key={relatedExport.reference}
              errorMessages={`Export trailer ${
                relatedExport?.reference || '(No Groupage)'
              } expects these packages to be loaded from ${`${
                baysAndRacks?.find(b => b.id == relatedExport?.expectedBayId)?.bayType[0]
              }${
                baysAndRacks?.find(b => b.id == relatedExport?.expectedBayId)?.bayNumber
              }`.toUpperCase()}`}
              type={'expected_bay'}
            />
          );
        }
      })}
      <MovementDetails movement={movement} category={category} job={job} />
      <div className="expected_actual_values">
        <div className="packages_ref">{'Reference: '}</div>
        <div className="value grey">{movement?.reference || 'Not provided'}</div>
        <div className="packages_expected_quantity">{'Expected Quantity: '}</div>
        <div className="value">
          {expQuantity} {expType}
        </div>
        <div className="packages_actual_quantity">{'Actual Quantity: '}</div>
        <div
          className={`value ${
            actQuantityItems != actQuantityPackages
              ? 'item_mismatch'
              : actQuantityPackages == expQuantity
              ? 'match'
              : 'mismatch'
          }`}
        >
          {actQuantityPackages} {actType}{' '}
          {actQuantityItems != actQuantityPackages && `(${actQuantityItems} items)`}
        </div>
        <div className="packages_expected_weight">{'Expected Weight: '}</div>
        <div className="value">{expWeight} kg</div>
        <div className="packages_actual_weight">{'Actual Weight: '}</div>
        <div className={`value ${actWeight == expWeight ? 'match' : 'mismatch'}`}>
          {actWeight} kg
        </div>
        <div className="packages_expected_volume">{'Expected Volume: '}</div>
        <div className="value">{expVolume} m³</div>
        <div className="packages_actual_volume">{'Actual Volume: '}</div>
        <div className={`value ${actVolume == expVolume ? 'match' : 'mismatch'}`}>
          {actVolume} m³
        </div>
      </div>

      {(movementType == 'collections' || movementType == 'imports') &&
        (packages?.length > 0 || completedPackages?.length > 0) && (
          <div className="job_package_lists">
            {jobs?.map(job => {
              if (
                packages?.filter(pkg => pkg?.job?.id == job?.id).length > 0 ||
                completedPackages?.filter(pkg => pkg?.job?.id == job?.id).length > 0
              ) {
                return (
                  <>
                    {packages?.filter(pkg => pkg?.job?.id == job?.id).length > 0 && (
                      <div className="section" key={job?.id}>
                        <PackageList
                          job={job}
                          packages={packages?.filter(pkg => pkg?.job?.id == job?.id)}
                          refetchPackages={() => {
                            getCompletedPackages();
                            getIncompletePackages();
                          }}
                          bays={bays}
                          racks={racks}
                        />
                      </div>
                    )}
                    {completedPackages?.filter(pkg => pkg?.job?.id == job?.id).length > 0 && (
                      <div className="section" key={job?.id}>
                        <div className="dispatched_title">
                          {`Dispatched (${
                            completedPackages?.filter(pkg => pkg?.job?.id == job?.id).length
                          } item${
                            completedPackages?.filter(pkg => pkg?.job?.id == job?.id).length > 1
                              ? 's'
                              : ''
                          })`}
                        </div>
                        <PackageList
                          disableMassAssign
                          packages={completedPackages.filter(pkg => pkg.manualCompletionReason)}
                          bays={bays}
                          racks={racks}
                          refetchPackages={() => {
                            getIncompletePackages();
                            getCompletedPackages();
                          }}
                          specialActionType={'complete_packages'}
                          completedPackages={completedPackages.filter(
                            pkg => !pkg.manualCompletionReason && pkg?.job?.id == job?.id,
                          )}
                          specialCompletedAction={pkgId =>
                            navigate(
                              `/jobs/${completedPackages?.find(pkg => pkg.id == pkgId)?.job?.id}`,
                            )
                          }
                        />
                      </div>
                    )}
                  </>
                );
              }
            })}
          </div>
        )}
      {(movementType == 'deliveries' || movementType == 'exports') &&
      (packages?.length > 0 || completedPackages?.length > 0)
        ? jobs?.map(job => {
            if (packages?.filter(pkg => pkg?.job?.id == job?.id).length > 0) {
              return (
                <AssociatedPackageList
                  key={job?.id}
                  movement={movement}
                  setLoading={setLoading}
                  assignedPackages={packages?.filter(pkg => pkg?.job?.id == job?.id)}
                  hubId={hubId}
                  bays={bays}
                  racks={racks}
                  setError={setError}
                  completed
                  movementType={movementType}
                  category={category}
                />
              );
            }
          })
        : ''}
      <MovementNotesPhotos
        setError={setError}
        movement={movement}
        movementType={movementType}
        completed
      />
      {movementType == 'deliveries' && (
        <div className="delivery_driver_details">
          <div className="driver_name">
            Driver name:
            <div className="value">{driverName}</div>
          </div>
          <div className="driver_signature">
            Signature:
            <div className="image_display">
              <img className="image" src={driverSignature} data-testid="image_display" />
            </div>
          </div>
        </div>
      )}
      <div className="completed_movement_buttons">
        <Button
          buttonType="red"
          className={`completed_movement_button unconfirm`}
          onClick={() => setModalOpen('unconfirm')}
          label="Unconfirm"
        />
      </div>
      {modalOpen && <Modal title={null} content={getModalType()} setModalOpen={setModalOpen} />}
    </div>
  );
};

CompletedMovement.propTypes = {
  setFromPending: PropTypes.func,
  getMovement: PropTypes.func,
  movement: PropTypes.object,
  setError: PropTypes.func,
  setLoading: PropTypes.func,
  category: PropTypes.string,
  movementType: PropTypes.string,
};

export default CompletedMovement;
